var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnticlockwiseDirection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4.37096C4 3.88994 4.38595 3.5 4.86205 3.5C5.33815 3.5 5.7241 3.88994 5.7241 4.37096V6.20545C8.36724 3.47228 12.5043 2.69182 15.9961 4.4125C20.417 6.59098 22.2528 11.9778 20.0966 16.4444C17.9404 20.9109 12.6087 22.7658 8.18779 20.5873C6.42218 19.7173 5.00871 18.3021 4.13399 16.5407C3.92047 16.1108 4.09235 15.5874 4.51789 15.3717C4.94343 15.156 5.46148 15.3296 5.67499 15.7596C6.38051 17.1802 7.5185 18.3194 8.94359 19.0217C12.5086 20.7784 16.8082 19.2827 18.547 15.6808C20.2858 12.0789 18.8053 7.73488 15.2403 5.97812C12.1143 4.43772 8.3828 5.39244 6.34539 8.14511H9.45966C9.93576 8.14511 10.3217 8.53505 10.3217 9.01607C10.3217 9.49709 9.93576 9.88703 9.45966 9.88703H4.86205C4.38595 9.88703 4 9.49709 4 9.01607V8.95065C3.99981 8.93671 4 4.37096 4 4.37096Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnticlockwiseDirection);
export default __webpack_public_path__ + "static/media/anticlockwise-direction.70253a255dcc05b9865fa2e9c8a8ef12.svg";
export { ForwardRef as ReactComponent };